import { useMemo } from 'react';
import { useStatuses } from '@/hooks/use-tasks';
import { SearchableSelect } from '@/components/ui/searchable-select';

export function StatusPicker({
  boardId,
  value,
  onChange,
  ariaInvalid,
  ariaLabel = 'Status',
}: {
  boardId: string;
  value: string;
  onChange: (id: string) => void;
  ariaInvalid?: boolean;
  ariaLabel?: string;
}) {
  const { data: statuses = [] } = useStatuses(boardId);
  const options = useMemo(() => statuses.map((s) => ({ id: s.id, name: s.name })), [statuses]);
  return (
    <SearchableSelect
      value={value}
      onChange={onChange}
      options={options}
      placeholder="Pick a status…"
      allowNone={false}
      ariaInvalid={ariaInvalid}
      ariaLabel={ariaLabel}
    />
  );
}

export function StatusChip({ boardId, value }: { boardId: string; value: string | undefined }) {
  const { data: statuses = [] } = useStatuses(boardId);
  const s = statuses.find((x) => x.id === value);
  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className="h-2 w-2 rounded-full shrink-0"
        style={{ background: s?.color ?? 'var(--muted-foreground)' }}
      />
      {s?.name ?? value ?? '—'}
    </span>
  );
}
